import { render, staticRenderFns } from "./ModifyIndividualStep2.vue?vue&type=template&id=6a15f017&scoped=true&"
import script from "./ModifyIndividualStep2.vue?vue&type=script&lang=js&"
export * from "./ModifyIndividualStep2.vue?vue&type=script&lang=js&"
import style0 from "./ModifyIndividualStep2.vue?vue&type=style&index=0&id=6a15f017&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a15f017",
  null
  
)

export default component.exports